export const routes = {
  home: '/Home',
  chat: '/Chat',
  search: '/Search',
  splash: '/',
}
